import { useTranslation } from "react-i18next";
import { FinancialApi as FinancialApiProd } from "../services/akfenservicesprod/api";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import RasyonetLine from "../assets/images/rasyonet-line.png";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { Dialog } from "primereact/dialog";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "chartjs-adapter-date-fns";

function Financial() {
  //#region API
  const financialProdApi = new FinancialApiProd({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = financialProdApi;

  //#endregion

  //#region useState
  const chartRef = useRef();
  const [visible, setVisible] = useState(false);
  const [selectedLang, setSelectedLang] = useState("");
  const [onlyYear, setOnlyYear] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [currencies, setCurrencies] = useState();
  const [quarter, setQuarter] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState();
  const [headerData, setHeaderData] = useState();
  const [pageData, setPageData] = useState([]);
  const [modalName, setModalName] = useState("");
  const [modalLabel, setModalLabel] = useState([]);
  const [modalData, setModalData] = useState([]);

  const chartOptions = {
    responsive: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const number = parseFloat(tooltipItem.raw);
            return number.toLocaleString();
          },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: "black",
          font: {
            size: 12,
            weight: "bold",
          },
          callback: function (label) {
            return label.toLocaleString();
          },
        },
      },
      x: {
        ticks: {
          color: "black",
          font: {
            size: 12,
            weight: "bold",
          }          
        },
      },
    },
  };
  
  const data = {
    labels: modalLabel,
    datasets: [
      {
        data: modalData,
        borderColor: "#cc2d41",
        backgroundColor: "#cc2d41",
        borderWidth: 0,
        fill: false,
      },
    ],
  };
  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  //#endregion

  //#region Page Load Data
  const financialData = () => {
    if (api !== undefined && api !== "") {
      api
        .financialReturnGet(
          selectedCurrency["name"],
          selectedLang === "tr-TR" ? 1 : 2,
          onlyYear,
          selectedQuarter,
          "sec.101.837"
        )

        .then((response) => {
          if (response.status === 200) {
            let datas = response.data;
            setHeaderData(datas["headers"]);
            setPageData(datas["values"]);
          }
        });
    }
  };

  const QuarterData = () => {
    if (api !== undefined && api !== "") {
      api.financialQuartersGet(selectedLang).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          var sortData = datas.reverse();
          setQuarter(sortData);
          setSelectedQuarter(sortData[0].value);
        }
      });
    }
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (window.location.pathname.indexOf("financial") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
      setCurrencies([
        { name: "TRL", code: "Turkish Lira" },
        { name: "USD", code: "Dollar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    } else {
      setSelectedLang("tr-TR");
      setCurrencies([
        { name: "TRL", code: "Türk Lirası" },
        { name: "USD", code: "Dolar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    }
  }, []);

  useEffect(() => {
    if (selectedLang !== undefined && selectedLang !== "") QuarterData();
  }, [selectedLang]);

  useEffect(() => {
    if (selectedQuarter !== undefined && selectedCurrency !== undefined)
      financialData();
  }, [selectedQuarter, selectedCurrency, onlyYear]);
  //#endregion

  //#region Page Helper

  const openModal = (item) => {    

    setModalName(item.c1);
    setVisible(true);
    
    var modalL = [item.cQ2, item.cQ3, item.cQ4, item.cQ5, item.cQ6];
    var modalD = [item.cV2, item.cV3, item.cV4, item.cV5, item.cV6];

    setModalLabel(modalL);
    setModalData(modalD);
  };

  const returnItem = (item, index) => {
    if (
      (index > 0 && selectedCurrency["name"] === "TRL") ||
      (index > 1 && selectedCurrency["name"] !== "TRL")
    ) {
      return (
        <i
          className="fas fa-eye"
          onClick={() => {
            openModal(item);
          }}
        ></i>
      );
    } else {
      <i></i>;
    }
  };

  const formatedDate = (value, index) => {
    if (value !== "" && value !== undefined && value.indexOf("T00") !== -1) {
      const isoDate = value;
      const formatted = moment(isoDate).format("DD.MM.YYYY");
      return formatted;
    } else return value;
  };

  //#endregion

  return (
    <>
      <div className="financial">
        <div className="pageHeader mb-4">
          <div className="title"> {t("KeyFinancialData")}</div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="selectArea d-flex align-items-center position-relative w-100">
              <Dropdown
                value={selectedCurrency}
                onChange={(e) => {
                  setSelectedCurrency(e.value);
                }}
                options={currencies}
                optionLabel="code"
                className=" customDropdown me-3"
                panelClassName="customDropdownPanel"
              />

              <Dropdown
                value={selectedQuarter}
                onChange={(e) => {
                  setSelectedQuarter(e.value);
                }}
                options={quarter}
                optionLabel="name"
                className=" customDropdown me-3"
                panelClassName="customDropdownPanel "
              />

              <Checkbox
                inputId="onlyYear"
                onChange={(e) => setOnlyYear(e.checked)}
                checked={onlyYear}
              />
              <label htmlFor="onlyYear" className="ms-2 checkLabel">
                {t("onlyYear")}
              </label>
            </div>

            <div className="financialTable d-inline-block position-relative w-100 mt-3">
              <table className="w-100">
                <thead>
                  <tr>
                    {headerData?.map((item, index) => (
                      <th key={index}>{item}</th>
                    ))}
                    <th className="text-center"> {t("Graphic")}</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.c1}</td>
                      <td>{formatedDate(item.c2, index)}</td>
                      <td>{formatedDate(item.c3, index)}</td>
                      <td>{formatedDate(item.c4, index)}</td>
                      <td>{formatedDate(item.c5, index)}</td>
                      <td>{formatedDate(item.c6, index)}</td>
                      <td>{returnItem(item, index)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="note text-end d-inline-block w-100">
              {t("financialNote1")} <br /> {t("financialNote2")} <br />{" "}
              {t("financialNote3")} <br /> {t("financialNote4")}
            </div>

            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang !== "tr-TR" ? "d-none" : ""
              }`}
            >
              ***** Piyasa verileri
              <Link to="https://www.rasyonet.com.tr/tr" target="_blank">
                <img src={RasyonetLine} />
              </Link>
              tarafından sağlanmaktadır.
            </div>
            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang === "tr-TR" ? "d-none" : ""
              }`}
            >
              ***** The share information data is provided by{" "}
              <Link to="https://www.rasyonet.com.tr/en" target="_blank">
                <img src={RasyonetLine} />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header={modalName}
        visible={visible}
        style={{ width: "45vw" }}
        onHide={() => setVisible(false)}
        draggable={false}
        className="customModal"
      >
        <Bar
          className="mt-2 w-100"
          ref={chartRef}
          data={data}
          height={400}
          width={800}
          options={chartOptions}
        />
      </Dialog>
    </>
  );
}

export default Financial;
